import errorMap from "@gap/backend/util/validations/validation-error-map"
import { z } from "zod"

const UserOrgPermissionEnums = [
   'business-plan'
] as const

const preWorkDocumentIdSchema = z.string().regex(/^Pre-work-[0-9A-HJKMNP-TV-Z]{26}$/) as z.ZodType<`Pre-work-${string}`>
const deliveryDocumentIdSchema = z.string().regex(/^Delivery-[0-9A-HJKMNP-TV-Z]{26}$/) as z.ZodType<`Delivery-${string}`>
const feedbackDocumentIdSchema = z.string().regex(/^Feedback-[0-9A-HJKMNP-TV-Z]{26}$/) as z.ZodType<`Feedback-${string}`>
const proposalSchema = z.string().regex(/^proposal-.+$/) as z.ZodType<`proposal-${string}`>
const markdownSchema = z.string().regex(/^markdown-.+$/) as z.ZodType<`markdown-${string}`>

export type UserOrgPermissionEnum = typeof UserOrgPermissionEnums[number] | `Pre-work-${string}` | `Delivery-${string}` | `Feedback-${string}` | `proposal-${string}` | `markdown-${string}`

export const UserOrgPermissionEnumsSchema: z.ZodType<UserOrgPermissionEnum> = z.union([
   z.enum(UserOrgPermissionEnums, { errorMap }),
   preWorkDocumentIdSchema,
   deliveryDocumentIdSchema,
   feedbackDocumentIdSchema,
   proposalSchema,
   markdownSchema
], { errorMap })
